import { useHits } from 'react-instantsearch'

//* Components
import Container from 'components/common/Container'
import Hit from './Hit'

const Hits = (props) => {
	const { hits } = useHits(props)
	return (
		<Container full row>
			{hits.map((i, k) => (
				<Hit key={k} {...i} imagePrefix={props.imagePrefix} />
			))}
		</Container>
	)
}

export default Hits
